export enum CpfServiceStatusEnum {
    pending = 'PENDING_APPLICANT',
  }
  